module.exports = __webpack_public_path__ + "static/media/image-card-7.39be4a6f.png";